module.exports = __webpack_public_path__ + "img/frame5.7b4599f7.jpg";